var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drawer-layout',[_c('div',{staticClass:"report-container mx-7 mt-4"},[_c('indicators-header',{attrs:{"type":_vm.type}}),_vm._v(" "),_c('indicators-wizard',{attrs:{"type":_vm.type}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }